module.exports = __webpack_public_path__ + "img/copy-to-clipboard.bf5eedbd.svg";